import React, { useState, useEffect } from 'react';
import { Button, Card, Modal, Table, Row, Col, Form, Pagination, Container } from 'react-bootstrap';
import axios from 'axios';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { useHistory } from 'react-router-dom';
import { var_api } from '../../constant';
import Swal from "sweetalert2";

const ClientList = () => {
  const [clientsData, setClientsData] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(25);
  const [popupLast30Days, setPopupLast30Days] = useState(false);
  const [startDate, setStartDate] = useState(getFormattedDate(30));
  const [endDate, setEndDate] = useState(getFormattedDate(0));
  const history = useHistory();

  useEffect(() => {
    fetchClients();
  }, [startDate, endDate]);

  function getFormattedDate(daysBeforeToday) {
    const date = new Date();
    date.setDate(date.getDate() - daysBeforeToday);
    return date.toISOString().split('T')[0];
  }

  const fetchClients = async () => {
    try {
      const token = localStorage.getItem('token');
      // const userId = localStorage.getItem('userId');
      const formattedStartDate = formatToDDMMYY(startDate);
      const formattedEndDate = formatToDDMMYY(endDate);
      const response = await axios.get(
        `${var_api}/api/booking/get-clients/${formattedStartDate}/${formattedEndDate}`,
        { headers: { Authorization: `${token}` } }
      );
      setClientsData(response.data);
      setPopupLast30Days(false);
    } catch (error) {
      console.error("Error fetching clients:", error);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
    }
  };

  const formatToDDMMYY = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  const filteredClients = clientsData.filter((client) => {
    const name = client.customer_name?.toLowerCase() || '';
    const email = client.email_id?.toLowerCase() || '';
    const address = client.address_location?.toLowerCase() || '';
    const country = client.country_name?.toLowerCase() || '';
    return (
      name.includes(searchQuery.toLowerCase()) ||
      email.includes(searchQuery.toLowerCase()) ||
      address.includes(searchQuery.toLowerCase()) ||
      country.includes(searchQuery.toLowerCase())
    );
  });

  const totalPages = Math.ceil(filteredClients.length / pageSize);
  const paginatedClients = filteredClients.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  const exportToExcel = () => {
    const data = paginatedClients.map((client, index) => ({
      'S.No': index + 1,
      'Name': client.customer_name,
      'Mobile No': client.customer_mobile,
      'Email': client.email_id || '-',
      'Location': client.address_location || '-',
      'Country': client.country_name || '-'
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Clients");
    XLSX.writeFile(wb, 'ClientsData.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    const columns = ["S.No", "Name", "Mobile No", "Email", "Location", "Country"];
    const rows = paginatedClients.map((client, index) => [
      index + 1,
      client.customer_name,
      client.customer_mobile,
      client.email_id || '-',
      client.address_location || '-',
      client.country_name || '-'
    ]);
    doc.autoTable({
      head: [columns],
      body: rows,
      theme: 'grid'
    });
    doc.save('ClientsData.pdf');
  };

  return (
    <Container className="activity-container mx-auto">
          <Button variant="dark" onClick={() => history.push('/reports')} className="mb-4">
            <i className='bx bx-arrow-back'></i> Back
          </Button>
          <h2 className="mb-4 text-center">Client List</h2>
          <p className="mb-4 text-center">Comprehensive list of all active clients.</p>

          <div className="filters mb-4 d-flex justify-content-between">
    <Button variant="dark" onClick={() => setPopupLast30Days(true)}>Date Filter</Button>
    <Form.Control
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="search"
            style={{ width: '200px' }} // Adjust width as needed
        />
  </div>

          <Modal show={popupLast30Days} onHide={() => setPopupLast30Days(false)} centered>
            <Modal.Header closeButton>
              <Modal.Title>Filter Last 30 Days</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-4">
                <Col>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </Col>
                <Col>
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </Col>
              </Row>
              <Button variant="dark" onClick={fetchClients}>Apply</Button>
              <Button variant="outline-secondary" onClick={() => setPopupLast30Days(false)} className="ms-2">Cancel</Button>
            </Modal.Body>
          </Modal>

          {/* <div className="d-flex justify-content-end mb-4">
            <Form.Control
              type="text"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search"
            />
          </div> */}

          <Table responsive bordered hover className="text-center">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Client</th>
                <th>Mobile No</th>
                <th>Email ID</th>
                <th>Address Location</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {paginatedClients.length > 0 ? (
                paginatedClients.map((client, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{client.customer_name}</td>
                    <td>{client.customer_mobile}</td>
                    <td>{client.email_id || '-'}</td>
                    <td>{client.address_location || '-'}</td>
                    <td>{client.country_name || '-'}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">No Data Available</td>
                </tr>
              )}
            </tbody>
          </Table>

          <div className="d-flex justify-content-start mt-4">
            <Button onClick={exportToPDF} variant="dark" className="btn btn-primary">Download as PDF</Button>
          </div>
          <div className="d-flex justify-content-start mt-4">
            <Button onClick={exportToExcel} variant="dark" className="btn btn-primary">Download as Excel</Button>
          </div>

          <Pagination className="mt-4 justify-content-center">
            <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Previous</Pagination.Prev>
            {[...Array(totalPages).keys()].map((_, idx) => (
              <Pagination.Item key={idx} active={currentPage === idx + 1} onClick={() => setCurrentPage(idx + 1)}>
                {idx + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}>Next</Pagination.Next>
          </Pagination>
    </Container>
  );
};

export default ClientList;
